export const checkIsGoodStatus = (status?: number) => {
  return status && status >= 200 && status < 400;
};
